import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { AdditionalSettingsFileExtension } from 'src/app/shared/models/admin.model';

@Component({
  selector: 'app-application-settings',
  templateUrl: './application-settings.component.html',
  styleUrls: ['./application-settings.component.scss']
})
export class ApplicationSettingsComponent implements OnInit {


  @Output() appSettingsClose = new EventEmitter();
  @Output() isUploadDrawerClose = new EventEmitter();

  appSettingsFormGroup: UntypedFormGroup;
  tooltipOptions: Object;
  blockedFileExtensions: string;
  abc: any;
  specialChar: string = "^[,.a-z ]*$";
  specialCharMsg: string = AppConstants.specialCharAdditionalSettings;
  fileSizeOption = [30, 50, 70, 90, 100, 200, 500, 1024];
  private unsubscribe: Subject<void> = new Subject<void>();
  isLoadingData: boolean = false;
  @Output() drawerClose: EventEmitter<any> = new EventEmitter<any>();
  listOfblockedExtension: any;
  acceptedFileExtension: any;
  listofAllowedFileExtensions: any;

  constructor(private formBuilder: UntypedFormBuilder,
    private adminRepository: AdminRepositoryService,
    private snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.appSettingsFormInitalize();
    this.getDefaultFileSize();
  }

  appSettingsFormInitalize() {
    this.appSettingsFormGroup = this.formBuilder.group({
      allowedFileSize: this.formBuilder.control('', [Validators.required])
    });

    let newValue = [];
  }

  getDefaultFileSize() {
    this.isLoadingData = true;
    this.adminRepository.getfileSize()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(val => {
        if (val) {
          this.allowedFileSize.setValue(val);
        } else {
          this.allowedFileSize.setValue(this.fileSizeOption[1]);
        }
        this.isLoadingData = false;
      })
  }

  onCancelClick() {
    this.appSettingsClose.emit(false);
  }

  onSaveClick() {
    this.isLoadingData = true;
    let appConfig: AdditionalSettingsFileExtension = {
      maxFileSizeUpload: this.allowedFileSize.value

    }
    if (this.appSettingsFormGroup.valid && this.appSettingsFormGroup.dirty) {
      this.adminRepository.updateFileExtension(appConfig)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(data => {
          if (data) {
            this.isLoadingData = false;
            this.drawerClose.emit(false);
            this.snackBarService.showSuccess('Changes saved successfully!');
          }
        }, (error) => {
          this.snackBarService.showError(error.message);
        });
    } else {
      this.isLoadingData = false;
      this.appSettingsFormGroup.markAllAsTouched();
    }
  }

  get allowedFileSize() {
    return this.appSettingsFormGroup.get('allowedFileSize') as UntypedFormControl;
  }
}
